import { useCallback } from 'react'
import { useAuth } from '../contexts/AuthContext'
import config from './config'

export const useApi = () => {
  const { token } = useAuth()

  const fetchWithAuth = useCallback(async (endpoint: string, options: RequestInit = {}) => {
    if (!token) {
      throw new Error('No authentication token available');
    }

    const headers = new Headers(options.headers)
    headers.set('Authorization', `Bearer ${token}`)

    const url = endpoint.startsWith('http') ? endpoint : `${config.apiUrl}${endpoint}`

    const response = await fetch(url, {
      ...options,
      headers,
      credentials: 'include',
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    return response
  }, [token])

  return { fetchWithAuth }
}
